<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style lang="less">
@font-face {
  font-family: "DINOT-mddium";
  src: url("./assets/js/DINOT-Medium.ttf");
  font-weight: normal;
  font-style: normal;
}

* {
  padding: 0;
  margin: 0;
}

* {
  // -webkit-transform: translateZ(0px);
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: auto;
  -ms-user-select: none;
  user-select: none;
}
img {
  -webkit-touch-callout: none;
}
input {
  -webkit-user-select: text !important;
}
#app {
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}
img {
  -webkit-touch-callout: none;
  pointer-events: none; // 像微信浏览器还是无法禁止，加上这行样式即可
}
html,
body {
  background: #f8f8f8;
  height: 100%;
}
body,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
input,
p,
blockquote,
th,
td {
  font-weight: 400;
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h4,
h5 {
  margin: 0;
  padding: 0;
}
body {
  background-color: #f8f8f8;
  color: #3c3c3c;
  font-size: 11px;
  text-align: left;
  font-family: "Alibaba-PuHuiTi-Regular";
}
select {
  font-size: 12px;
}
table {
  border-collapse: collapse;
}
fieldset,
img {
  border: 0 none;
}
fieldset {
  margin: 0;
  padding: 0;
}
fieldset p {
  margin: 0;
  padding: 0 0 0 8px;
}
legend {
  display: none;
}
address,
caption,
em,
strong,
th,
i {
  font-style: normal;
  font-weight: 400;
}
table caption {
  margin-left: -1px;
}
hr {
  border-bottom: 1px solid #ffffff;
  border-top: 1px solid #e4e4e4;
  border-width: 1px 0;
  clear: both;
  height: 2px;
  margin: 5px 0;
  overflow: hidden;
}
ol,
ul {
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
}
caption,
th {
  text-align: left;
}
q:before,
q:after,
blockquote:before,
blockquote:after {
  content: ””;
}
</style>
